<template>
    <div class="product_image_wrapper">
        <div class="product_slider_wrapper">
            <div v-if="images.length" class="product_slider jsProductSlider">
                <client-only>
                    <vue-slick-carousel
                        ref="forSlider"
                        class="slider_for jsProductFor"
                        :arrows="false"
                        :slides-to-show="1"
                        :slides-to-scroll="1"
                        :touch-treshold="150"
                        :dots="false"
                        :speed="250"
                        :as-nav-for="navSlider"
                        :responsive="[
                            {
                                breakpoint: 768,
                                settings: {
                                    dots: true
                                }
                            }
                        ]"
                    >
                        <div
                            v-for="(image, index) in images"
                            :key="`slider_for_${index}`"
                            class="slide_block"
                        >
                            <div class="image_wrapper">
                                <div
                                    v-full-background-image-path="image"
                                    class="image bg_image contain"
                                />
                            </div>
                        </div>
                    </vue-slick-carousel>
                    <vue-slick-carousel
                        ref="navSlider"
                        class="slider_nav jsProductNav"
                        :slides-to-show="4"
                        :slides-to-scroll="1"
                        focus-on-select
                        :swipe="false"
                        :dots="false"
                        infinite
                        :as-nav-for="forSlider"
                        :responsive="[
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            }
                        ]"
                    >
                        <div
                            v-for="(image, index) in images"
                            :key="`slider_nav_${index}`"
                            class="slide_block"
                        >
                            <div class="image_wrapper">
                                <div
                                    v-full-background-image-path="image"
                                    class="image bg_image contain"
                                />
                            </div>
                        </div>
                    </vue-slick-carousel>
                </client-only>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
    components: {
        VueSlickCarousel
    },

    props: {
        images: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            forSlider: null,
            navSlider: null
        };
    },

    async mounted() {
        await this.$nextTick();

        this.forSlider = this.$refs.forSlider;
        this.navSlider = this.$refs.navSlider;
    }
};
</script>
